import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"



const Header = ({ siteTitle }) => (
  <header>
    <div
      className="container-fluid"
    >
      <div className="row justify-content-center py-4">
        <p style={{ margin: 0, textTransform: `uppercase` }} className="display-3">
          <Link
            to="/"
            style={{
              color: `#707070`,
              textDecoration: `none`,
            }}
          >
            {siteTitle}
          </Link>
        </p>
      </div>
      </div>
      <nav className="nav nav-justified">
        <div className="dropdown nav-fluid-width">
          <button className="nav-link nav-item color-one dropdown-toggle" id="navbarAboutDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">About</button>
          <div className="dropdown-menu color-one" aria-labelledby="navbarAboutDropdown" id="aboutDropdown">
            <Link className="dropdown-item" to="/about">About Us</Link>
            <Link className="dropdown-item" to="/who-we-are">Who We Are</Link>
          </div>
        </div>
        <div className="dropdown nav-fluid-width">
          <button className="nav-link nav-item color-two dropdown-toggle" id="navbarProjectsDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Projects</button>
          <div className="dropdown-menu color-two" aria-labelledby="navbarProjectsDropdown" id="projectDropdown">
            <Link className="dropdown-item" to="/cams-unboxed-life">Cam's Unboxed Life</Link>
            <Link className="dropdown-item" to="/shows-arts">Shows & Arts</Link>
            <a className="dropdown-item" href="https://www.divergencenz.com/">DIVERGENCE</a>
            <Link className="dropdown-item" to="/community-connection">Community Connection</Link>
            <Link className="dropdown-item" to="/gallery">Gallery</Link>
          </div>
        </div>
        <div className="d-sm-block d-xs-block d-md-none d-lg-none w-100"></div>
        <Link className="nav-link nav-item color-three" to="/events">Events</Link>
        <Link className="nav-link nav-item color-four" to="/blog">Blog</Link>
        <Link className="nav-link nav-item color-five" to="/contact">Contact</Link>
      </nav>
    
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
